export default __webpack_public_path__ + "f810f776678de0c6dcfb75ca999d9727.png";